/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import ErrorAction from "../../Commands/ErrorAction";

export type Level = "Success" | "Info" | "Warning" | "Error";
export type Code =
    | ""
    | "EXEC_CONCURRENCY_CONFLICT"
    | "EXEC_DATA_NOT_FOUND"
    | "EXEC_INVALID_OPERATION"
    | "EXEC_INTERNAL_ERROR"
    | "EXEC_PDF_ERROR"
    | "AUTH_NOT_AUTHORIZED"
    | "AUTH_FEHLER";

export const levelRanking = {
    Success: 1,
    Info: 2,
    Warning: 3,
    Error: 4,
};

export const codeRanking = {
    "": 1,
    EXEC_INVALID_OPERATION: 1,
    EXEC_PDF_ERROR: 1,
    EXEC_DATA_NOT_FOUND: 2,
    EXEC_CONCURRENCY_CONFLICT: 3,
    AUTH_NOT_AUTHORIZED: 4,
    EXEC_INTERNAL_ERROR: 5,
    AUTH_FEHLER: 6,
};

export default interface AppSnackbarItem {
    source: string;
    message: string;
    level: Level;
    code: Code;
    path: Array<string>;
    referenceId: string;
    referenceMatchcode: string;
    referenceTypeName: string;
    errorId: string;
    action?: ErrorAction;
}
